import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { AnimatePresence, motion } from "framer-motion";
import { MdOutlineChevronLeft, MdOutlineChevronRight } from "react-icons/md";
import { displayImage } from "../../helpers/config";

function Gallery({ images = ["", ""], callback }) {
  const [currentImage, setCurrentImage] = useState(0);

  const nextImage = () => {
    if (currentImage === images?.length - 1) {
      setCurrentImage(0);
    } else {
      setCurrentImage(currentImage + 1);
    }
  };

  const prevImage = () => {
    if (currentImage === 0) {
      setCurrentImage(images?.length - 1);
    } else {
      setCurrentImage(currentImage - 1);
    }
  };

  return (
    <div className="w-full h-full fixed top-0 left-0 z-50">
      {/* Images */}
      <div className="relative z-40 mx-auto w-fit h-full flex justify-center items-center">
        <div className="max-w-[650px]">
          <AnimatePresence>
            {images?.map(
              (image, i) =>
                currentImage === i && (
                  <motion.img
                    key={i}
                    src={displayImage(image)}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className=" object-contain w-full h-full"
                    crossOrigin="anonymous"
                    loading="lazy"
                  />
                ),
            )}
          </AnimatePresence>
        </div>
      </div>
      {/* Overflow */}
      <div
        className="absolute top-0 left-0 bg-white w-full h-full z-30 cursor-pointer"
        onClick={() => callback()}
      ></div>
      {/* Close Btn */}
      <div className="absolute z-50 top-8 right-10 flex justify-center items-center border size-14 rounded-full cursor-pointer">
        <motion.button onClick={() => callback()}>
          <IoCloseOutline size={25} />
        </motion.button>
      </div>

      {/* Navigation */}
      <div className="absolute w-fit bg-white z-50 bottom-8 left-1/2 -translate-x-1/2 p-4 rounded-full border flex justify-center items-center px-5">
        <div className="flex items-center gap-4">
          <button onClick={prevImage}>
            <MdOutlineChevronLeft size={25} />
          </button>
          <p className="text-gray-400">
            {currentImage + 1} / {images.length}
          </p>
          <button onClick={nextImage}>
            <MdOutlineChevronRight size={25} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
